import React from "react";
import { AcordoStatus } from "core/features/acordo/enums";
import { Flex } from "@chakra-ui/react";
import SelectableButton from "components/Button/SelectableButton";
import colors from "core/resources/theme/colors";

interface TagsAcordosProps {
  status?: AcordoStatus;
  onChangeStatus: (status?: AcordoStatus) => void;
}

function TagsAcordos({ status, onChangeStatus }: TagsAcordosProps) {
  return (
    <Flex flex={1} gridGap="16px">
      <SelectableButton
        selected={status === AcordoStatus.Pago}
        onClick={() => {
          onChangeStatus(AcordoStatus.Pago);
        }}
        onUnselect={() => {
          onChangeStatus();
        }}
        rounded="full"
        selectedColor={colors.blue300}
        fontSize="14px"
      >
        Pago
      </SelectableButton>

      <SelectableButton
        selected={status === AcordoStatus.EmAberto}
        onClick={() => {
          onChangeStatus(AcordoStatus.EmAberto);
        }}
        onUnselect={() => {
          onChangeStatus();
        }}
        rounded="full"
        selectedColor={colors.yellow500}
        fontSize="14px"
      >
        Em Aberto
      </SelectableButton>

      <SelectableButton
        selected={status === AcordoStatus.Cancelado}
        onClick={() => {
          onChangeStatus(AcordoStatus.Cancelado);
        }}
        onUnselect={() => {
          onChangeStatus();
        }}
        rounded="full"
        selectedColor={colors.red500}
        fontSize="14px"
      >
        Cancelado
      </SelectableButton>

      <SelectableButton
        selected={status === AcordoStatus.Renegociado}
        onClick={() => {
          onChangeStatus(AcordoStatus.Renegociado);
        }}
        onUnselect={() => {
          onChangeStatus();
        }}
        rounded="full"
        selectedColor={colors.blue500}
        fontSize="14px"
      >
        Renegociado
      </SelectableButton>

      <SelectableButton
        selected={status === AcordoStatus.Encerrado}
        onClick={() => {
          onChangeStatus(AcordoStatus.Encerrado);
        }}
        onUnselect={() => {
          onChangeStatus();
        }}
        rounded="full"
        selectedColor={colors.blue500}
        fontSize="14px"
      >
        Encerrado
      </SelectableButton>
    </Flex>
  );
}

export default TagsAcordos;
